import { useEffect, useState } from 'react';

import TradingView from '../../trading-view';
import NormalChartPlugin from './NormalChartPlugin';
import PatternChartPlugin from './PatternChartPlugin';

interface Props {
  tv: TradingView | undefined;
  patternId?: string;
}

const SetupChartPatternIdentifier = ({ tv, patternId }: Props) => {
  const [isInit, setIsInit] = useState(false);

  useEffect(() => {
    if (!tv || isInit) return;

    const init = () => {
      setIsInit(true);
    };

    tv.on('onFirstDataLoaded', init);
    return () => tv.off('onFirstDataLoaded', init);
  }, [tv, isInit]);

  if (!tv || !isInit) return null;
  if (patternId) return <PatternChartPlugin tv={tv} patternId={patternId} />;
  return <NormalChartPlugin tv={tv} />;
};

export default SetupChartPatternIdentifier;
